import { type RouteRecordRaw } from 'vue-router'
import countries from 'src/assets/countries.json'

declare module 'vue-router' {
  interface RouteMeta {
    title?: string
    requiresAuth?: boolean
    showHeader?: boolean
    showFilterBar?: boolean
  }
}

const countryCodes = countries.map(({ code }) => code)

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: `:countryCode(${countryCodes.join('|')})`,
        children: [
          {
            path: 'login',
            children: [
              {
                path: '',
                name: 'login',
                component: () => import('pages/AuthPage.vue'),
              },
              {
                path: 'request-password-reset',
                name: 'request-password-reset',
                component: () => import('pages/AuthPage.vue'),
              },
              {
                path: 'set-password',
                name: 'set-password',
                component: () => import('pages/AuthPage.vue'),
              },
            ],
          },
          {
            path: 'signup',
            children: [
              {
                path: '',
                name: 'signup-request',
                component: () => import('pages/AuthPage.vue'),
              },
              {
                path: 'set-password',
                name: 'set-initial-password',
                component: () => import('pages/AuthPage.vue'),
              },
            ],
          },
          {
            path: 'my-yeply',
            name: 'my-yeply',
            meta: { requiresAuth: true, showHeader: true },
            component: () => import('pages/MyYeplyPage.vue'),
          },
          {
            path: ':area?',
            meta: { showHeader: true },
            children: [
              {
                path: '',
                meta: { showFilterBar: true },
                component: () => import('pages/IndexPage.vue'),
              },
              {
                path: 'booking/:id',
                name: 'booking',
                component: () => import('pages/BookingPage.vue'),
              },
            ],
          },
        ],
      },
      {
        path: 'booking/prepayment/:publicToken',
        name: 'booking-prepayment-status',
        meta: { showHeader: true },
        component: () => import('pages/BookingPrepaymentPage.vue'),
      },
      {
        path: '/',
        meta: { showHeader: true },
        component: () => import('pages/HomePage.vue'),
      },
    ],
  },
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
]

export default routes
